import React from "react";

export default ({ progress, max, wrapperStyle, fillStyle }) => (
    <div className="progress-bar" style={wrapperStyle}>
        <div className="progress-bar__fill" style={{...fillStyle, width: Math.min((progress / max) * 100, 100) + "%"}}></div>
    </div>
)